@if (!hasPermission) {
  <div class="flex items-center justify-center gap-2 rounded-lg border border-red-200 bg-red-50 p-6 text-sm font-semibold text-red-700">
    <mat-icon class="!text-base text-red-400">lock</mat-icon>
    Permissions Restricted
  </div>
} @else {
  <div>
    <div class="mb-3 flex items-center justify-between">
      <h3 class="text-secondary text-sm font-semibold uppercase tracking-wide">Performance Benchmarking</h3>
      <!-- Pill-style toggle -->
      <div class="flex rounded-full border border-gray-200 bg-gray-50 p-0.5 text-xs">
        <button
          class="rounded-full px-3 py-1 font-semibold transition-colors"
          [class.bg-primary]="activeTab === 'collection'"
          [class.text-white]="activeTab === 'collection'"
          [class.text-gray-500]="activeTab !== 'collection'"
          (click)="activeTab = 'collection'"
        >
          Collection
        </button>
        <button
          class="rounded-full px-3 py-1 font-semibold transition-colors"
          [class.bg-primary]="activeTab === 'sr'"
          [class.text-white]="activeTab === 'sr'"
          [class.text-gray-500]="activeTab !== 'sr'"
          (click)="activeTab = 'sr'"
        >
          Service Req
        </button>
      </div>
    </div>

    @if (loading) {
      <div class="flex justify-center py-6"><mat-spinner diameter="28" color="primary" /></div>
    }

    @if (error && !loading) {
      <div class="text-secondary flex items-center gap-2 py-3 text-sm">
        <mat-icon class="text-base text-gray-400">error_outline</mat-icon>
        {{ error }}
      </div>
    }

    @if (!error && !loading) {
      @let rows = activeTab === 'collection' ? collectionData : srData;
      @let pctKey = activeTab === 'collection' ? 'pct' : 'closure_pct';

      @if (rows.length === 0) {
        <div class="flex flex-col items-center gap-1.5 rounded-lg border border-dashed border-gray-200 py-8 text-center">
          <mat-icon class="!text-3xl text-gray-300">bar_chart</mat-icon>
          <span class="text-xs text-gray-400">No data available</span>
        </div>
      }

      <div class="divide-y divide-gray-50">
        @for (row of rows.slice(0, 5); track row.id; let i = $index) {
          <div class="flex items-center gap-2.5 py-2 transition-colors hover:bg-gray-50">
            <!-- Rank badge -->
            <span class="flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-gray-100 text-[10px] font-bold text-gray-500">{{ i + 1 }}</span>
            <!-- Name -->
            <span class="w-28 shrink-0 truncate text-xs font-medium text-gray-700" [title]="row.name">{{ row.name }}</span>
            <!-- Progress bar -->
            <div class="h-1.5 flex-1 overflow-hidden rounded-full bg-gray-100">
              <div
                class="h-full rounded-full transition-all duration-500"
                [class.bg-green-500]="row[pctKey] >= 90"
                [class.bg-yellow-400]="row[pctKey] >= 70 && row[pctKey] < 90"
                [class.bg-red-400]="row[pctKey] < 70"
                [style.width.%]="row[pctKey]"
              ></div>
            </div>
            <!-- Percentage pill -->
            <span
              class="w-14 shrink-0 rounded-full px-1.5 py-0.5 text-center text-[10px] font-bold leading-none"
              [class.bg-green-100]="row[pctKey] >= 90"
              [class.text-green-700]="row[pctKey] >= 90"
              [class.bg-yellow-100]="row[pctKey] >= 70 && row[pctKey] < 90"
              [class.text-yellow-700]="row[pctKey] >= 70 && row[pctKey] < 90"
              [class.bg-red-100]="row[pctKey] < 70"
              [class.text-red-700]="row[pctKey] < 70"
            >
              {{ row[pctKey] }}%
            </span>
          </div>
        }
      </div>
    }
  </div>
}
